<nz-table
	#sectionTable
	[nzData]="sections()"
	[nzBordered]="true"
	[nzShowPagination]="true"
	[nzFrontPagination]="false"
	[nzPageIndex]="pageNumber()"
	[nzPageSize]="SECTIONS_PER_PAGE"
	[nzTotal]="totalSections()"
	(nzPageIndexChange)="onPageIndexChange($event)"
	nzSize="small"
	[nzLoading]="loading()"
>
	<thead>
		<tr>
			<th
				nzWidth="40%"
				[nzSortFn]="sortNameFn"
				[nzSortOrder]="sortOrder()"
				(nzSortOrderChange)="onSortOrderChange($event)"
			>
				Name
			</th>
			<th nzWidth="20%">Language</th>
			<th nzWidth="20%">Location Name</th>
			<th nzWidth="20%">Code</th>
		</tr>
	</thead>
	<tbody>
		@for (section of sectionTable.data; track section) {
			<tr
				[class.selected]="selectedSection()?.uuid === section.uuid"
				class="section-row"
				(click)="selectSection(section)"
			>
				<td>{{ section.name }}</td>
				<td>{{ section.language }}</td>
				<td>{{ section.location_uuid | locationName | async }}</td>
				<td>{{ section.section_code }}</td>
			</tr>
		}
	</tbody>
</nz-table>
